import api from '../api';

export default {
    async getTrabalhos(params: any = {}) {
        return api.get('/trabalhos', { params });
    },

    async createTrabalho(data: any) {
        return api.post('/trabalhos', data);
    },

    async getTrabalho(id: number) {
        return api.get(`/trabalhos/${id}`);
    },

    async updateTrabalho(id: number, data: any) {
        return api.put(`/trabalhos/${id}`, data);
    },

    async deleteTrabalho(id: number) {
        return api.delete(`/trabalhos/${id}`);
    },

    async updateTemplate(id: number, templateId: number) {
        return api.put(`/trabalhos/${id}/template`, { template_id: templateId });
    },

    // Métodos específicos de coordenador
    async getTrabalhosCoordenador(params: any) {
        return api.get('/coordenador/trabalhos', { params });
    },

    async createTrabalhoOficial(data: any) {
        return api.post('/coordenador/trabalhos', data);
    },

    async getTrabalhoCoordenador(id: number) {
        return api.get(`/coordenador/trabalhos/${id}`);
    },

    async updateTrabalhoCoordenador(id: number, data: any) {
        return api.put(`/coordenador/trabalhos/${id}`, data);
    },

    async deleteTrabalhoCoordenador(id: number) {
        return api.delete(`/coordenador/trabalhos/${id}`);
    },

    async getAlunosDisponiveis(cursoId: number, params: Record<string, any> = {}) {
        return api.get(`/coordenador/cursos/${cursoId}/alunos`, { params });
    },

    async searchAlunosDisponiveis(cursoId: number, search: string, extraParams: Record<string, any> = {}) {
        return api.get(`/coordenador/cursos/${cursoId}/alunos`, {
            params: {
                ...extraParams,
                search,
                limit: 50,
            },
        });
    },

    async getProfessoresDisponiveis(cursoId: number, params: Record<string, any> = {}) {
        return api.get(`/coordenador/cursos/${cursoId}/professores`, { params });
    },

    async searchProfessoresDisponiveis(cursoId: number, search: string, extraParams: Record<string, any> = {}) {
        return api.get(`/coordenador/cursos/${cursoId}/professores`, {
            params: {
                ...extraParams,
                search,
                limit: 50,
            },
        });
    },
};
